(() => {
  const sectionSelector = '[data-pp-product-section]';

  function getGallery(section) {
    return {
      mainImage: section.querySelector('.pp-product-main-media img'),
      thumbs: [...section.querySelectorAll('[data-pp-gallery-thumb]')],
      dots: [...section.querySelectorAll('[data-pp-gallery-dot]')],
    };
  }

  function getCurrentIndex(thumbs) {
    const activeIndex = thumbs.findIndex((thumb) => thumb.getAttribute('aria-current') === 'true');
    return activeIndex >= 0 ? activeIndex : 0;
  }

  function normalizeIndex(index, total) {
    if (!total) return 0;
    return ((index % total) + total) % total;
  }

  function updateActiveState(thumbs, dots, currentIndex) {
    thumbs.forEach((thumb, index) => {
      if (index === currentIndex) {
        thumb.setAttribute('aria-current', 'true');
        thumb.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
      } else {
        thumb.removeAttribute('aria-current');
      }
    });

    dots.forEach((dot, index) => {
      if (index === currentIndex) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  function showImage(section, requestedIndex) {
    const { mainImage, thumbs, dots } = getGallery(section);
    if (!mainImage || !thumbs.length) return;

    const currentIndex = normalizeIndex(requestedIndex, thumbs.length);
    const activeThumb = thumbs[currentIndex];
    const src = activeThumb.dataset.gallerySrc;
    const alt = activeThumb.dataset.galleryAlt || '';

    if (!src) return;

    mainImage.style.opacity = '0.15';
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.src = src;
    mainImage.alt = alt;
    updateActiveState(thumbs, dots, currentIndex);

    window.requestAnimationFrame(() => {
      mainImage.style.opacity = '1';
    });
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const control = event.target.closest([
      '[data-pp-gallery-previous]',
      '[data-pp-gallery-next]',
      '[data-pp-gallery-thumb]',
      '[data-pp-gallery-dot]',
      '[data-pp-quantity-minus]',
      '[data-pp-quantity-plus]',
      '[data-pp-purchase-mode]',
    ].join(','));

    if (!control) return;

    const section = control.closest(sectionSelector);
    if (!section) return;

    event.preventDefault();
    event.stopPropagation();

    if (control.matches('[data-pp-gallery-previous]')) {
      const { thumbs } = getGallery(section);
      showImage(section, getCurrentIndex(thumbs) - 1);
      return;
    }

    if (control.matches('[data-pp-gallery-next]')) {
      const { thumbs } = getGallery(section);
      showImage(section, getCurrentIndex(thumbs) + 1);
      return;
    }

    if (control.matches('[data-pp-gallery-thumb], [data-pp-gallery-dot]')) {
      const index = Number.parseInt(control.dataset.galleryIndex, 10);
      if (!Number.isNaN(index)) showImage(section, index);
      return;
    }

    const quantityInput = section.querySelector('[data-pp-quantity-input]');
    if (control.matches('[data-pp-quantity-minus]') && quantityInput) {
      const value = Number.parseInt(quantityInput.value, 10) || 1;
      quantityInput.value = Math.max(1, value - 1);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    if (control.matches('[data-pp-quantity-plus]') && quantityInput) {
      const value = Number.parseInt(quantityInput.value, 10) || 1;
      quantityInput.value = value + 1;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    if (control.matches('[data-pp-purchase-mode]')) {
      const purchaseButtons = section.querySelectorAll('[data-pp-purchase-mode]');
      const sellingPlanInput = section.querySelector('[data-pp-selling-plan-input]');

      purchaseButtons.forEach((button) => button.classList.remove('is-active'));
      control.classList.add('is-active');

      if (sellingPlanInput) {
        sellingPlanInput.value = control.dataset.ppPurchaseMode === 'subscribe'
          ? control.dataset.sellingPlanId || ''
          : '';
      }
    }
  }, true);

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element) || !event.target.matches('[data-variant-input]')) return;

    const section = event.target.closest(sectionSelector);
    const mediaSrc = event.target.dataset.mediaSrc;
    if (!section || !mediaSrc) return;

    const { thumbs } = getGallery(section);
    const matchedIndex = thumbs.findIndex((thumb) => {
      const thumbSrc = thumb.dataset.gallerySrc || '';
      return thumbSrc === mediaSrc || thumbSrc.includes(mediaSrc) || mediaSrc.includes(thumbSrc);
    });

    if (matchedIndex >= 0) showImage(section, matchedIndex);
  }, true);
})();
